import React from 'react';
export const StorySection: React.FC = () => {
  return <section className="py-16 md:py-24" data-id="element-246">
      <div className="section-container" data-id="element-247">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-248">
          <div className="space-y-6" data-id="element-249">
            <h2 className="text-3xl md:text-4xl font-literata font-medium text-deep-juniper" data-id="element-250">
              Your story, understood without judgment.
            </h2>
            <p className="text-lg text-plum-gray leading-relaxed" data-id="element-251">
              Re:Joy's Smart Intake listens deeply. You describe your experience
              in your own words; we translate it into insight that therapists
              can act on, in your tone, context, and pace.
            </p>
            <div className="space-y-5 pt-2" data-id="element-252">
              <div className="flex items-start gap-4" data-id="element-253">
                <div className="w-8 h-8 rounded-full bg-mist-sage/30 flex items-center justify-center flex-shrink-0" data-id="element-254">
                  <svg className="w-4 h-4 text-deep-juniper" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-255">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-256"></path>
                  </svg>
                </div>
                <div className="flex-1" data-id="element-257">
                  <h4 className="font-medium text-deep-juniper mb-1" data-id="element-258">
                    Safe Start
                  </h4>
                  <p className="text-plum-gray leading-relaxed" data-id="element-259">
                    You can begin safely and confidently: our system ensures immediate routing
                    to support if needed.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-260">
                <div className="w-8 h-8 rounded-full bg-mist-sage/30 flex items-center justify-center flex-shrink-0" data-id="element-261">
                  <svg className="w-4 h-4 text-deep-juniper" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-262">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-263"></path>
                  </svg>
                </div>
                <div className="flex-1" data-id="element-264">
                  <h4 className="font-medium text-deep-juniper mb-1" data-id="element-265">
                    Voice My Story
                  </h4>
                  <p className="text-plum-gray leading-relaxed" data-id="element-266">
                    Describe your experience in your own words. AI listens, not
                    judges.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-267">
                <div className="w-8 h-8 rounded-full bg-mist-sage/30 flex items-center justify-center flex-shrink-0" data-id="element-268">
                  <svg className="w-4 h-4 text-deep-juniper" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-269">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-270"></path>
                  </svg>
                </div>
                <div className="flex-1" data-id="element-271">
                  <h4 className="font-medium text-deep-juniper mb-1" data-id="element-272">
                    Comfort Zones
                  </h4>
                  <p className="text-plum-gray leading-relaxed" data-id="element-273">
                    Define what makes you feel safe and respected in therapy.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="rounded-2xl bg-white shadow-card p-8 flex items-center justify-center" data-id="element-274">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jNvLNmAZhREQCA3R8FPqKY/growth_elements.svg" alt="Stylized plant with coral-colored central element surrounded by leaf shapes, symbolizing personal growth and healing" className="w-full max-w-md" data-id="element-275" />
          </div>
        </div>
      </div>
    </section>;
};